<mat-toolbar class="mat-toolbar-azul">
  <img [src]="logoVisorWeb" width="250" height="auto" fxHide.xs>
  <img [src]="logoVisorWeb" width="200" height="90%" fxShow.xs fxHide.sm fxHide.lg fxHide.md
    fxHide.xl>
  <span class="spacer-banner"></span>
  <button mat-icon-button (click)="closeDialogAgregarEmpresa()" class="menu-button">
    <mat-icon matSuffix>close</mat-icon>
  </button>
</mat-toolbar>
<mat-card class="card-grey">
  <mat-card-title class="card-title">AGREGAR EMPRESA PRESUPUESTO</mat-card-title>
  <mat-card-content>
    <div class="mat-elevation-z4 divmarco">
      <form [formGroup]="registerCompanyForm" (ngSubmit)="onSubmit()">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.sm="column" fxLayout.md="row"
        fxLayout.xs="column" class="divconten" style="padding-top: 15px;">
          <mat-form-field fxLayout="column" fxFlex="grow" appearance="outline" floatLabel="always"
            [ngClass]="classFlag ? 'input-width-240' : 'input-width-275'">
              <mat-label>Empresa:</mat-label>
              <input matInput formControlName="nombreEmpresa" name="nombreEmpresa" minlength="4" maxlength="50"
                autocomplete="off" required>
              <mat-error *ngIf="registerCompanyForm.controls['nombreEmpresa'].hasError('required')">Empresa es
                requerida.</mat-error>
              <mat-error *ngIf="registerCompanyForm.controls['nombreEmpresa'].hasError('minlength')">Nombre debe
                ser mínimo 4 caracteres.
              </mat-error>
              <mat-error *ngIf="registerCompanyForm.controls['nombreEmpresa'].hasError('maxlength')">Nombre debe
                ser máximo 50 caracteres.
              </mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.sm="column" fxLayout.md="row"
          fxLayout.xs="column" class="divconten" style="padding-top: 15px;">
            <mat-form-field fxLayout="column" appearance="outline" floatLabel="always"
              [ngClass]="classFlag ? 'input-width-240' : 'input-width-275'">
              <mat-label>R.I.F.:</mat-label>
              <input matInput formControlName="numRif" name="numRif" minlength="1" maxlength="100" autocomplete="off" required>
              <mat-error *ngIf="registerCompanyForm.controls['numRif'].hasError('required')">RIF es requerido. Ejemplo:
                J-123456789</mat-error>
              <mat-error *ngIf="registerCompanyForm.controls['numRif'].hasError('pattern')">RIF inválido. Debe tener VEJPG, guión y
                números.</mat-error>
              <mat-error *ngIf="registerCompanyForm.controls['numRif'].hasError('minlength')">RIF debe ser mínimo 1
                caracteres.</mat-error>
              <mat-error *ngIf="registerCompanyForm.controls['numRif'].hasError('maxlength')">RIF debe ser máximo 100 caracteres.
              </mat-error>
            </mat-form-field>
            <mat-form-field fxLayout="column" appearance="outline" floatLabel="always"
              [ngClass]="classFlag ? 'input-width-240' : 'input-width-275'">
              <mat-label>N.I.T.:</mat-label>
              <input matInput formControlName="numNit" name="numNit" minlength="1" maxlength="100" autocomplete="off">
              <mat-error *ngIf="registerCompanyForm.controls['numNit'].hasError('minlength')">NIT debe
                ser mínimo 1 caracteres.
              </mat-error>
              <mat-error *ngIf="registerCompanyForm.controls['numNit'].hasError('maxlength')">NIT debe
                ser máximo 100 caracteres.
              </mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.sm="column" fxLayout.md="row"
          fxLayout.xs="column" class="divconten" style="padding-top: 15px;">
            <mat-form-field fxLayout="column" fxFlex="grow" appearance="outline" floatLabel="always"
              [ngClass]="classFlag ? 'input-width-240' : 'input-width-275'">
              <mat-label>Dirección Fiscal:</mat-label>
              <input matInput formControlName="direccionEmpresa" name="direccionEmpresa" minlength="10" maxlength="250"
                autocomplete="off">
              <mat-error *ngIf="registerCompanyForm.controls['direccionEmpresa'].hasError('minlength')">Nombre debe
                ser mínimo 10 caracteres.
              </mat-error>
              <mat-error *ngIf="registerCompanyForm.controls['direccionEmpresa'].hasError('maxlength')">Nombre debe
                ser máximo 250 caracteres.
              </mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.sm="column" fxLayout.md="row"
          fxLayout.xs="column" class="divconten-padding-top">
            <mat-form-field fxLayout="column" appearance="outline" floatLabel="always"
              [ngClass]="classFlag ? 'input-width-240' : 'input-width-275'">
              <mat-label>Teléfono:</mat-label>
              <input matInput formControlName="numTelefonoEmpresa" name="numTelefonoEmpresa" mask="(000) 000-0000"
                minlength="10" maxlength="15" autocomplete="off">
              <mat-error *ngIf="registerCompanyForm.controls['numTelefonoEmpresa'].hasError('minlength')">Teléfono
                inválido. Formato:
                (000) 000-0000</mat-error>
            </mat-form-field>
            <mat-form-field fxLayout="column" appearance="outline" floatLabel="always"
              [ngClass]="classFlag ? 'input-width-240' : 'input-width-275'">
              <mat-label>Correo Electrónico:</mat-label>
              <input matInput formControlName="correoEmpresa" name="correoEmpresa" maxlength="50" autocomplete="off">
              <mat-error *ngIf="registerCompanyForm.controls['correoEmpresa'].hasError('pattern')">Correo inválido.
                Formato: ejemplo&#64;correo.com</mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.sm="column" fxLayout.md="row"
          fxLayout.xs="column" class="divconten" style="padding-top: 15px;">
            <mat-form-field fxLayout="column" fxFlex="grow" appearance="outline" floatLabel="always"
              [ngClass]="classFlag ? 'input-width-240' : 'input-width-275'">
              <mat-label>Representante Legal:</mat-label>
              <input matInput formControlName="nombreRepresentante" name="nombreRepresentante" minlength="4"
                maxlength="20" autocomplete="off">
              <mat-error *ngIf="registerCompanyForm.controls['nombreRepresentante'].hasError('minlength')">Nombre debe
                ser mínimo 4 caracteres.
              </mat-error>
              <mat-error *ngIf="registerCompanyForm.controls['nombreRepresentante'].hasError('maxlength')">Nombre debe
                ser máximo 50 caracteres.
              </mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
          class="divconten">
          <div fxLayout="column">
            <button mat-raised-button color="warn" type="button" (click)="closeDialogAgregarEmpresa()"
              class="align-center-middle">
              <span class="text-icon-space">Regresar</span>
              <mat-icon>restart_alt</mat-icon>
            </button>
          </div>
          <div fxLayout="column">
            <button mat-raised-button color="primary" type="summit" class="align-center-middle">
              <span class="text-icon-space">Guardar</span>
              <mat-icon>save</mat-icon>
            </button>
          </div>
        </div>
      </form>
    </div>
  </mat-card-content>
</mat-card>